var resetPasswordSubmit = {
  submitButton: $('#reset_password_submit'),

  init: function () {
    this.form = this.submitButton.closest('form');
    toastr.options.positionClass = 'toast-bottom-center';

    var app = this;
    this.submitButton.on('click', function (event) {
      if (app.form[0].checkValidity()) {
        app.prepareFormValues();
        event.preventDefault();
        $('.error-messages').remove();
        app.submitForm(app.form.serialize());
      }
    });
  },
  submitForm: function (serializedForm) {
    var app = this;
    $.ajax({
      url: this.form.attr('action'),
      method: 'POST',
      data: serializedForm,
      beforeSend: function () {
        app.disableButton(true);
      },
      success: function (response) {
        if (response.ok || response.isOk) {
          app.showMessage(response.message, 'success');
          $('.modal').removeClass('js-active');
          $('body').removeClass('js-freeze');
        } else {
          app.showMessage(response.message, 'warning');
        }
      },
      error: function (response) {
        app.showMessage(response.responseJSON.message, 'error');
      },
      complete: function (jqXHR, status) {
        app.enableButton();
        app.form[0].reset();
      },
    });
  },
  showMessage: function (message, type) {
    toastr[type](message);
  },
  disableButton: function () {
    this.submitButton.attr('disabled', 'disabled');
  },
  enableButton: function () {
    this.submitButton.attr('disabled', false);
  },
  prepareFormValues: function () {
    var searchParams = new URLSearchParams(window.location.search);
    $('#reset_password_resetPasswordToken').val(
      searchParams.get('reset-password-token')
    );
  },
};

$(function () {
  resetPasswordSubmit.init();
});
